import { render, staticRenderFns } from "./AppActionRemark.vue?vue&type=template&id=777e2916"
import script from "./AppActionRemark.vue?vue&type=script&lang=js"
export * from "./AppActionRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports